import { inferAdditionalFields } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  basePath: "/api/auth",
  fetchOptions: {
    credentials: "same-origin",
  },
  plugins: [
    inferAdditionalFields({
      user: {
        businessName: {
          type: "string",
          required: true,
        },
        instagramHandle: {
          type: "string",
          required: true,
        },
      },
    }),
  ],
});
